import { documentSchema } from 'app/src/msw/membership/schemas/document'
import { funnelSchema } from 'app/src/msw/membership/schemas/enums'
import {
  BalanceRange,
  CompanyWelfareCampaign,
  CompanyWelfareConfiguration,
  FrontendConfiguration,
} from 'app/src/services/welfareportal/membership-api'

// eslint-disable-next-line import/no-named-as-default
import z from 'zod'

export const balanceRangeSchema: z.ZodType<BalanceRange> = z.object({
  from: z.number(),
  to: z.number(),
  msgKey: z.string(),
})

export const contactInfoSchema: z.ZodType<{ email?: string; phone?: string }> = z.object({
  email: z.string().max(255).optional(),
  phone: z.string().max(20).optional(),
})

export const frontendConfigurationSchema: z.ZodType<FrontendConfiguration> = z.object({
  templateId: z.string(),
  companyLogoPath: z.string(),
  cssPath: z.string(),
  contactInfo: contactInfoSchema.optional(),
})

export const companyWelfareConfigurationSchema: z.ZodType<CompanyWelfareConfiguration> = z.object({
  frontend: frontendConfigurationSchema,
  funnels: z.array(funnelSchema).max(100),
  backofficeFunnels: z.array(funnelSchema).max(100).optional(),
  familyMemberPrivacyDocument: z.boolean(),
  familyMembersRelations: z
    .array(
      z.enum([
        'coniuge',
        'fratello_sorella',
        'figlio_figlia',
        'genero_nuora',
        'suocero_suocera',
        'genitore',
        'genitore_convivente',
        'genitore_percettore',
      ]),
    )
    .max(50),
  fringeWarningThreshold: z.number().min(0).max(100).optional(),
  refundSettleMode: z.enum(['iban', 'payslip']).optional(),
  spendingReminder: z
    .object({
      thresholdDays: z.string(),
      ranges: z.array(balanceRangeSchema),
    })
    .optional(),
})

export const companyWelfareCampaignSchema: z.ZodType<CompanyWelfareCampaign> = z.object({
  campaignName: z.string().max(255),
  phase: z.enum(['pre-join', 'join', 'pre-fruition', 'fruition', 'closed']),
  companyCode: z.string().max(50),
  campaignId: z.string().max(50),
  companyName: z.string().max(255),
  mustJoin: z.boolean(),
  joinDateFrom: z.string().datetime().optional(),
  joinDateTo: z.string().datetime().optional(),
  fruitionDateFrom: z.string().datetime(),
  fruitionDateTo: z.string().datetime(),
  documents: z.array(documentSchema),
  configuration: companyWelfareConfigurationSchema,
})
